/**
 * axios setup to use mock service
 */

import axios from 'axios';

const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3010/',
  headers: {
    'X-Synergy-Client-Type-Id': import.meta.env.VITE_API_CLIENT_TYPE
    // TODO - config request timeout
  }
});

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // TODO - handle request timeout
    // Handle 401 error
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('serviceToken');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
